var map = {
	"./Bitmap.png": "j2BA",
	"./aboutus/2022.png": "dJ+Z",
	"./aboutus/about.png": "RhaQ",
	"./aboutus/about_banner.png": "p4Oa",
	"./aboutus/about_icon01.png": "j+L4",
	"./aboutus/about_icon02.png": "2bI2",
	"./aboutus/banner-img.png": "cTks",
	"./aboutus/banner.png": "QgU8",
	"./aboutus/bg.png": "Vau/",
	"./aboutus/content_email.png": "u907",
	"./aboutus/content_fax.png": "+qtM",
	"./aboutus/content_tel.png": "HoW2",
	"./aboutus/develop.png": "X7H2",
	"./aboutus/hexinyewu.png": "26IM",
	"./aboutus/location_bg.png": "2tmL",
	"./aboutus/location_pic.png": "aGez",
	"./aboutus/map_bg.png": "8nuQ",
	"./aboutus/stage-info.png": "wBnV",
	"./aboutus/stagepostion.png": "bhSh",
	"./aboutus/title_bg.png": "nNLM",
	"./area2.png": "tuDC",
	"./area3.png": "X5vn",
	"./arr_blue.png": "bCtv",
	"./arr_white.png": "v74I",
	"./eidDetails.png": "KLdQ",
	"./ewm.png": "4+fO",
	"./footer_bg.png": "ZkCN",
	"./gongan.png": "cW4A",
	"./government/Business_environment.png": "i8vk",
	"./government/Industry_data.png": "9qYi",
	"./government/banner-home.png": "D2Kj",
	"./government/banner-newhome.png": "HL+D",
	"./government/banner-newone.png": "XVn8",
	"./government/banner.png": "r8j8",
	"./government/banner2.png": "u21S",
	"./government/cash.png": "tqCz",
	"./government/deal.png": "A5/q",
	"./government/enterprise.png": "dQwz",
	"./government/fastport.png": "O6QM",
	"./government/icon-1-s.png": "ArIe",
	"./government/icon-1.png": "WHeI",
	"./government/icon-2-s.png": "zFbb",
	"./government/icon-2.png": "9uUZ",
	"./government/icon-3-s.png": "6wKO",
	"./government/icon-3.png": "mB4q",
	"./government/icon-4-s.png": "alAm",
	"./government/icon-4.png": "TGyd",
	"./government/icon-5-s.png": "/WX6",
	"./government/icon-5.png": "Oju3",
	"./government/icon-6-s.png": "06Cp",
	"./government/icon-6.png": "sgNr",
	"./government/icon-7-s.png": "mmbv",
	"./government/icon-7.png": "QDKS",
	"./government/icon-8-s.png": "SdYH",
	"./government/icon-8.png": "frki",
	"./government/icon1.png": "dVTP",
	"./government/icon2.png": "cWjN",
	"./government/icon3.png": "cx6F",
	"./government/item_sel.png": "ehBZ",
	"./government/jianshui.png": "Tppk",
	"./government/leftCon.png": "1wtB",
	"./government/list_bg.png": "38lt",
	"./government/matter.png": "+aMO",
	"./government/new-banner-gar.png": "J5sG",
	"./government/new-garbanner.png": "4pe+",
	"./government/policy.png": "N2dh",
	"./government/publicService/banner.png": "mcHc",
	"./government/publicService/nth1.png": "kysQ",
	"./government/publicService/service_bg.png": "Pph0",
	"./government/publicService/start0.png": "gRmW",
	"./government/publicService/start1.png": "PFmb",
	"./government/rightTitle.png": "v7sE",
	"./helpCenter/Fill.png": "DaqH",
	"./helpCenter/QRcode@2x.png": "vEYE",
	"./helpCenter/WeChat@2x.png": "ZxVc",
	"./helpCenter/archive-fill-pre@2x.png": "zouF",
	"./helpCenter/archive-fill@2x.png": "6yKc",
	"./helpCenter/arrow.png": "HXkX",
	"./helpCenter/arrow_1.png": "tOBr",
	"./helpCenter/assistant@2x.png": "2O10",
	"./helpCenter/banner-img.png": "mL8i",
	"./helpCenter/banner.png": "YuVF",
	"./helpCenter/bit-coin-fill-pre@2x.png": "yaAh",
	"./helpCenter/bit-coin-fill@2x.png": "fTHj",
	"./helpCenter/book-open-fill-pre@2x.png": "U8Tq",
	"./helpCenter/book-open-fill@2x.png": "BSBa",
	"./helpCenter/close.png": "D6eP",
	"./helpCenter/emotion-fill-pre@2x.png": "gy1V",
	"./helpCenter/emotion-fill@2x.png": "dsC+",
	"./helpCenter/emotion-unhappy-fill@2x.png": "unDF",
	"./helpCenter/emotion-unhappy-pre@2x.png": "4LSS",
	"./helpCenter/finance-pre@2x.png": "JUHe",
	"./helpCenter/flag-2-fill-pre@2x.png": "1MAk",
	"./helpCenter/home-3-fill@2x.png": "k1n3",
	"./helpCenter/industry.png": "eV3K",
	"./helpCenter/industrys-pre@2x.png": "NuRH",
	"./helpCenter/logistics-pre@2x.png": "GFMo",
	"./helpCenter/open.png": "ol3S",
	"./helpCenter/picture@2x.png": "s+FW",
	"./helpCenter/policy-pre@2x.png": "KCaq",
	"./helpCenter/rectangle@2x.png": "/I57",
	"./home-v2/ArrowSelection.png": "tEQ7",
	"./home-v2/BackgroundMultimodalTransportCollaboration_1.png": "f6C0",
	"./home-v2/BackgroundOfMultimodalTransportCollaboration.png": "knAt",
	"./home-v2/BottomBackground.png": "Qa7B",
	"./home-v2/CentralizedPurchase.png": "F7PI",
	"./home-v2/Check.png": "WFY8",
	"./home-v2/Credit.png": "Bquw",
	"./home-v2/FindFinancing.png": "sTc4",
	"./home-v2/FindGoods.png": "URCZ",
	"./home-v2/FindInformation.png": "0EHn",
	"./home-v2/FindLogistics.png": "8meP",
	"./home-v2/FindPolicy.png": "84U9",
	"./home-v2/GovernmentAffairs.png": "MmVl",
	"./home-v2/IllustrationOfMultimodalTransportCollaboration.png": "qeB7",
	"./home-v2/LogisticsIntegration.png": "FaWs",
	"./home-v2/MonovalentSystem.png": "o+yY",
	"./home-v2/MultimodalTransport.png": "grmN",
	"./home-v2/NewsBackground.png": "Eadw",
	"./home-v2/OptimizeBusiness.png": "Rc7P",
	"./home-v2/PolicyDirectAccess.png": "n5aB",
	"./home-v2/TotalFreigtVolume.png": "Q3ff",
	"./home-v2/TotalRailwayFreightVolume.png": "wzAh",
	"./home-v2/TotalRoadFreightVolume.png": "CY6f",
	"./home-v2/TotalWaterFreightVolume.png": "rMni",
	"./home-v2/Verticalindustry.png": "hou6",
	"./home-v2/application.png": "hWSS",
	"./home-v2/arrowhead.png": "ZCgx",
	"./home-v2/banner.png": "358O",
	"./home-v2/banner2.png": "Qw12",
	"./home-v2/bg.png": "9DJJ",
	"./home-v2/bigData.png": "iMBp",
	"./home-v2/cancel.png": "yjfb",
	"./home-v2/coordination.png": "x589",
	"./home-v2/fangzi.png": "NOhc",
	"./home-v2/money.png": "ICGm",
	"./home-v2/newFindPolicy.png": "4amc",
	"./home-v2/news.png": "+lNJ",
	"./home-v2/onlineRetailers.png": "izcE",
	"./home-v2/pay.png": "83x4",
	"./home-v2/publicService.png": "eEIu",
	"./home-v2/serviceMask.png": "petu",
	"./home-v2/slices.png": "YpHW",
	"./home-v2/warrant.png": "SjXk",
	"./home-v2/鄂链通.png": "/yyz",
	"./home.png": "KSZv",
	"./home/arr.png": "+zOd",
	"./home/arr_blue.png": "9gB9",
	"./home/bwjt.png": "8b46",
	"./home/cooperation_bg.png": "REB7",
	"./home/ediTitleImg.png": "pHxf",
	"./home/feedback_icon01.png": "gRVM",
	"./home/feedback_icon02.png": "KshA",
	"./home/feedback_icon03.png": "K8b3",
	"./home/feedback_icon04.png": "ZAia",
	"./home/feedback_icon05.png": "0C7A",
	"./home/footer_ewm.png": "TLz5",
	"./home/footer_tel.png": "hlLC",
	"./home/gfyh.png": "kJM6",
	"./home/government_bg1.png": "MDK0",
	"./home/government_bg2.png": "yfPh",
	"./home/government_bg3.png": "yypJ",
	"./home/government_bg4.png": "7H4s",
	"./home/hbjj.png": "tpSA",
	"./home/hnnxs.png": "d5rb",
	"./home/hot_icon01.png": "iHKq",
	"./home/hot_icon02.png": "a9y7",
	"./home/hot_icon03.png": "qaBG",
	"./home/hot_icon04.png": "+WJc",
	"./home/hot_icon05.png": "tRze",
	"./home/hot_icon06.png": "nlAF",
	"./home/hxyh.png": "30yK",
	"./home/icon_dyglzs.png": "OaU1",
	"./home/icon_dyjyds.png": "x1FM",
	"./home/icon_gknttl.png": "9rJ1",
	"./home/icon_glhyzl.png": "fxiZ",
	"./home/icon_hbcs.png": "4Iwb",
	"./home/icon_hwyttl.png": "H7MF",
	"./home/icon_hyysl.png": "ERb5",
	"./home/icon_jzxyttl.png": "sXj8",
	"./home/icon_kdywl.png": "N4g6",
	"./home/icon_lscyncl.png": "5/61",
	"./home/icon_lscynscjye.png": "Vkku",
	"./home/icon_mtcyncl.png": "QbaP",
	"./home/icon_mtcynjye.png": "FdnM",
	"./home/icon_mtcynjyl.png": "E521",
	"./home/icon_syhyl.png": "sXE/",
	"./home/icon_tlhyzl.png": "OXKz",
	"./home/icon_wmhwyttl.png": "3Ksh",
	"./home/icon_ysqyzs.png": "+dvo",
	"./home/icon_yyhyzl.png": "exAf",
	"./home/icon_yzjd.png": "FUlp",
	"./home/icon_zoblkxlc.png": "vb8R",
	"./home/icon_zoblxl.png": "RkcW",
	"./home/jfld.png": "XEya",
	"./home/jmt.png": "lw0c",
	"./home/jsyh.png": "KrD1",
	"./home/jyjk.png": "kmNm",
	"./home/lyr.png": "lAMt",
	"./home/main_logistics_bg.png": "gOew",
	"./home/main_logo.png": "B7M4",
	"./home/main_search_btn.png": "PwN9",
	"./home/main_supply_bg.png": "o+yc",
	"./home/main_user_pic.png": "QY1g",
	"./home/mkjt.png": "T4Aq",
	"./home/news_pic.png": "IXRU",
	"./home/payh.png": "df6i",
	"./home/pfyh.png": "ahZ8",
	"./home/tyjr.png": "o3MR",
	"./home/wcbx.png": "aJGi",
	"./home/yinhao.png": "jZJg",
	"./home/yyt.png": "OYiO",
	"./home/zczy.png": "Ox4+",
	"./home/zgmd.png": "0SKd",
	"./home/zgtp.png": "Sqj5",
	"./home/zgwy.png": "HmZl",
	"./home/zljt.png": "5MXh",
	"./home/zsj.png": "5WRb",
	"./home/zsy.png": "FTFm",
	"./home/zsyh.png": "xIpq",
	"./home/zzgm.png": "A6Rr",
	"./huahanghanya.png": "08Sa",
	"./industryCenter/banner-home.png": "WqrV",
	"./industryCenter/banner.png": "NPpv",
	"./industryCenter/dazong.png": "z2oW",
	"./industryCenter/fuwu.png": "5rXe",
	"./industryCenter/homeMenu_bg.png": "VDIH",
	"./industryCenter/industryCenter_01.png": "Rupb",
	"./industryCenter/industryCenter_02.png": "9b5z",
	"./industryCenter/jicai.png": "dhCR",
	"./industryCenter/jiesuan.png": "2JE1",
	"./industryCenter/leiji.png": "tMeC",
	"./industryCenter/ruzhu.png": "baU2",
	"./industryCenter/wuliu.png": "SUh4",
	"./industryCenter/wuliuziyuan.png": "81kN",
	"./lihuowang.png": "X/I3",
	"./linshi/dcfw.png": "B6Yo",
	"./linshi/glwlgz.png": "pZ6f",
	"./linshi/glxxdt.png": "4KMA",
	"./linshi/glzxxd.png": "Yvi+",
	"./linshi/itemDetail.png": "8oVV",
	"./linshi/policyApply.png": "fa/Y",
	"./linshi/policyDetail.png": "CNz8",
	"./linshi/wlgz.png": "iZ6+",
	"./linshi/xxdt.png": "s0UC",
	"./linshi/zxxd.png": "rk0c",
	"./login/leftBg.png": "2QTB",
	"./login/leftTopLogo.png": "mMzC",
	"./login/login-bg.png": "/HQc",
	"./login/loginBg.png": "U05m",
	"./login/loginLogo.png": "/Q6T",
	"./login/passWord.png": "G8Ja",
	"./login/qq.png": "4Y57",
	"./login/rqCode.png": "Q3gJ",
	"./login/tiktok.png": "LouY",
	"./login/userName.png": "L8ce",
	"./login/userNameTab.png": "9zMP",
	"./login/weChat.png": "xxXn",
	"./login/weibo.png": "7P2o",
	"./login/xslLogo.png": "0f4O",
	"./logistics/Air freight picture.png": "aTwH",
	"./logistics/Postal service picture.png": "J9i1",
	"./logistics/Railway freight_image.png": "8cmR",
	"./logistics/Road freight picture.png": "SS2a",
	"./logistics/Warehousing supervision picture.png": "SPKc",
	"./logistics/Waterway freight picture.png": "lgHb",
	"./logistics/banner-home.png": "QT3U",
	"./logistics/banner.png": "Amwu",
	"./logistics/bj.png": "oi7f",
	"./logistics/gong1.png": "qv3g",
	"./logistics/gong2.png": "nVhd",
	"./logistics/gong3.png": "V7A2",
	"./logistics/icon1.png": "a7t6",
	"./logistics/icon2.png": "DLIg",
	"./logistics/icon3.png": "AG3+",
	"./logistics/icon4.png": "hZUt",
	"./logistics/icon5.png": "mD0n",
	"./logistics/left.png": "DRG1",
	"./logistics/leftBack.png": "xoCy",
	"./logistics/leftIcon.png": "7w+2",
	"./logistics/list1.png": "JewM",
	"./logistics/list2.png": "8tMe",
	"./logistics/list3.png": "BVGY",
	"./logistics/list4.png": "d6hZ",
	"./logistics/list5.png": "hwPs",
	"./logistics/list6.png": "m/Tl",
	"./logistics/qd.png": "nalt",
	"./logistics/right.png": "8mDw",
	"./logistics/shui.png": "keyh",
	"./logistics/shui1.png": "d736",
	"./logistics/shui2.png": "CSzb",
	"./logistics/shui3.png": "vW/Q",
	"./logistics/shui4.png": "Bceq",
	"./logistics/shui_list.png": "8YMs",
	"./logistics/tab1.png": "ot44",
	"./logistics/tab2.png": "3U4g",
	"./logistics/tab3.png": "Hfo5",
	"./logistics/tab4.png": "CTNa",
	"./logistics/tab5.png": "B0pb",
	"./logistics/tab6.png": "lj/o",
	"./logistics/wuliu.png": "lfcV",
	"./logistics/zs.png": "PlyY",
	"./logisticsBigData/BG@2x.png": "XigM",
	"./logisticsBigData/Group@2x.png": "2lz5",
	"./logisticsBigData/Iron_ore@2x.png": "a4zi",
	"./logisticsBigData/PostOffice@2x.png": "f5ie",
	"./logisticsBigData/Railway@2x.png": "tGMq",
	"./logisticsBigData/TP@2x.png": "lVdP",
	"./logisticsBigData/aviation@2x.png": "fzRz",
	"./logisticsBigData/background@2x.png": "JhpD",
	"./logisticsBigData/banner@2x.png": "UI5d",
	"./logisticsBigData/coal@2x.png": "hIRd",
	"./logisticsBigData/comprehensive@2x.png": "kySr",
	"./logisticsBigData/foodstuff@2x.png": "hx67",
	"./logisticsBigData/highway@2x.png": "d7s8",
	"./logisticsBigData/logo.png": "CvB1",
	"./logisticsBigData/medium_bg.png": "QF+2",
	"./logisticsBigData/monitor@2x.png": "t77f",
	"./logisticsBigData/security@2x.png": "rI1T",
	"./logisticsBigData/traffic@2x.png": "RwCd",
	"./logisticsBigData/visualization@2x.png": "ZLxu",
	"./logisticsBigData/waterTransport@2x.png": "RJjK",
	"./logo/government.png": "2w4h",
	"./logo/index.png": "zqB6",
	"./logo/indexnew.png": "jP/3",
	"./logo/industryCenter.png": "GSjc",
	"./logo/logistics.png": "f8ry",
	"./logo/logisticsBigData.png": "YghQ",
	"./logo/newblack.png": "v738",
	"./logo/roadFreight.png": "DsYU",
	"./logo/supplyFinance.png": "w51W",
	"./logo/supplychain.png": "Y81v",
	"./logo/title-logo.png": "t0JW",
	"./logo/waterage.png": "Z8iv",
	"./mesuggestions/banner-img.png": "DBQh",
	"./mesuggestions/banner.png": "Q9Sf",
	"./moneyStage/log2.png": "+1M0",
	"./moneyStage/log3.png": "5T4P",
	"./moneyStage/logo1.png": "on9J",
	"./newsCenter/banner-img.png": "slLH",
	"./newsCenter/home-3-fill@2x.png": "uX7X",
	"./newsCenter/mask@2x.png": "qgZn",
	"./newsCenter/news-banner.png": "al1l",
	"./newsCenter/news@2x.png": "a+mh",
	"./newsCenter/picture@2x.png": "FF9J",
	"./newsCenter/right@2x.png": "xy9m",
	"./productStage/1.png": "bSvO",
	"./productStage/2.png": "wQ5V",
	"./productStage/3.png": "JAfw",
	"./productStage/4.png": "poKz",
	"./productStage/5.png": "W1vz",
	"./productStage/6.png": "NtgZ",
	"./productStage/7.png": "DEUh",
	"./productStage/carlogo.png": "3hy6",
	"./productStage/hubeimylogo.png": "vwB/",
	"./productStage/icon1.png": "7ato",
	"./productStage/icon2.png": "Tm0D",
	"./productStage/img_ship.png": "jOWS",
	"./productStage/jiuzhoulogo.png": "HWg/",
	"./productStage/logo.3a1cd8d9.png": "D4cD",
	"./productStage/logo.png": "h7b6",
	"./productStage/logonew.ca732c61.png": "g/9x",
	"./productStage/meitanlogo.png": "wtUW",
	"./productStage/otLogo.png": "kCkG",
	"./productStage/otLogohf.png": "A7zn",
	"./productStage/otLogohf2.png": "NCu9",
	"./productStage/otLogojm.png": "dO7F",
	"./productStage/otLogozx.png": "PlYn",
	"./productStage/spl.png": "kd/5",
	"./productStage/title.png": "p7n0",
	"./productStage/titlelog.png": "IiMg",
	"./productStage/wuhanmylogo.png": "+NSd",
	"./productStage/xnyzk.png": "90aL",
	"./productStage/xyotLogo.png": "yuGK",
	"./productStage/yunxilogo.png": "sdiA",
	"./productStage/yunyan.png": "7YfK",
	"./productStage/yyotLogo.png": "Jv4U",
	"./serviceCenter/Group 1381.png": "Uehh",
	"./serviceCenter/Group_1415.png": "WLoE",
	"./serviceCenter/Group_1416.png": "N94p",
	"./serviceCenter/banner-img.png": "JiBH",
	"./serviceCenter/banner-img02.png": "Aitj",
	"./serviceCenter/chuanbo.png": "9XtQ",
	"./serviceCenter/download.png": "FZYS",
	"./serviceCenter/huashan.png": "/RxS",
	"./serviceCenter/icon_01.png": "nOf1",
	"./serviceCenter/icon_02.png": "FoGQ",
	"./serviceCenter/icon_03.png": "0djk",
	"./serviceCenter/icon_04.png": "k26i",
	"./serviceCenter/icon_05.png": "imb0",
	"./serviceCenter/icon_one.png": "++Kd",
	"./serviceCenter/icon_three.png": "itPi",
	"./serviceCenter/icon_two.png": "nCKJ",
	"./serviceCenter/information_bg.png": "BDRA",
	"./serviceCenter/jingkai.png": "pZOS",
	"./serviceCenter/jinkong.png": "tUO+",
	"./serviceCenter/jinkou.png": "i9wH",
	"./serviceCenter/kuaisubanli.png": "+YdD",
	"./serviceCenter/left_icon.png": "2fFj",
	"./serviceCenter/noData.png": "OlZ4",
	"./serviceCenter/noDataTwo.png": "OYCR",
	"./serviceCenter/noData_big.png": "k51M",
	"./serviceCenter/right_icon.png": "7b74",
	"./serviceCenter/search_icon.png": "zca8",
	"./serviceCenter/yangluo.png": "zYlp",
	"./serviceCenter/yijianchaxun.png": "vrMw",
	"./serviceCenter/yijianchaxun_all.png": "a9IP",
	"./serviceCenter/zhuanghuo.png": "DujI",
	"./serviceCenter/zonghexinxi.png": "T78R",
	"./supplyFinance/banner-home.png": "nZBt",
	"./supplyFinance/banner.png": "avQl",
	"./supplyFinance/cdzy_icon.png": "y6JV",
	"./supplyFinance/cdzy_image.png": "N1ZQ",
	"./supplyFinance/cxye_icon.png": "v1rV",
	"./supplyFinance/cxye_selected_icon.png": "66sU",
	"./supplyFinance/cxye_selected_image.png": "rklK",
	"./supplyFinance/drcktioong.png": "Wimk",
	"./supplyFinance/dzsb_icon.png": "0z2V",
	"./supplyFinance/dzsb_selected_icon.png": "/R/5",
	"./supplyFinance/dzsb_selected_image.png": "/YCk",
	"./supplyFinance/fd_icon.png": "wv/f",
	"./supplyFinance/fpdj_icon.png": "wENf",
	"./supplyFinance/fpdj_selected_icon.png": "nJAh",
	"./supplyFinance/fpdj_selected_image.png": "wfVU",
	"./supplyFinance/fpjz_selected_image.png": "qA2R",
	"./supplyFinance/fpzz_icon.png": "jkLH",
	"./supplyFinance/fpzz_selected_icon.png": "yy0H",
	"./supplyFinance/gyl_icon.png": "w4Vt",
	"./supplyFinance/icon1.png": "puiy",
	"./supplyFinance/icon2.png": "BCAi",
	"./supplyFinance/icon3.png": "P2nU",
	"./supplyFinance/icon4.png": "Ie/B",
	"./supplyFinance/icon_pzqf.png": "fQje",
	"./supplyFinance/icon_pzqf_on.png": "th8v",
	"./supplyFinance/icon_pzzr.png": "ehBt",
	"./supplyFinance/icon_pzzr_on.png": "QJQd",
	"./supplyFinance/icon_qfgl.png": "JPoj",
	"./supplyFinance/icon_qfgl_on.png": "nmW1",
	"./supplyFinance/icon_qyjd.png": "Fpv3",
	"./supplyFinance/icon_qyjd_on.png": "A2MK",
	"./supplyFinance/icon_rzbj.png": "fsvu",
	"./supplyFinance/icon_rzbj_on.png": "B/Xh",
	"./supplyFinance/icon_sxgl.png": "bFWB",
	"./supplyFinance/icon_sxgl_on.png": "NqOt",
	"./supplyFinance/icon_zcwh.png": "6900",
	"./supplyFinance/icon_zcwh_on.png": "iZrG",
	"./supplyFinance/image@1x.png": "IqO5",
	"./supplyFinance/jy_icon.png": "AgXO",
	"./supplyFinance/logo.png": "OXGA",
	"./supplyFinance/newbg.png": "yoTC",
	"./supplyFinance/paleterlayer.png": "1h3m",
	"./supplyFinance/rz-icon.png": "7z3U",
	"./supplyFinance/server_info.png": "6zHh",
	"./supplyFinance/yfrz_image.png": "jnMf",
	"./supplyFinance/yfzz_icon.png": "nFDX",
	"./supplyFinance/yspz_icon.png": "4TCV",
	"./supplyFinance/yspz_selected_icon.png": "S/Ei",
	"./supplyFinance/yspz_selected_image.png": "c2HC",
	"./supplyFinance/ysrz_icon.png": "7cEj",
	"./supplyFinance/ysrz_selected_icon.png": "fi/n",
	"./supplyFinance/ysrz_selected_image.png": "i6bG",
	"./supplyFinance/yszk_icon.png": "6pkr",
	"./supplyFinance/yszk_selected_icon.png": "oS2v",
	"./supplyFinance/yszk_selected_image.png": "667t",
	"./supplychain/1_1.png": "Q3N6",
	"./supplychain/1_2.png": "za8M",
	"./supplychain/1_3.png": "JKv+",
	"./supplychain/1_4.png": "KN+T",
	"./supplychain/1_5.png": "cC6+",
	"./supplychain/1_6.png": "/kr1",
	"./supplychain/1_7.png": "DrIm",
	"./supplychain/1_8.png": "WIUm",
	"./supplychain/2_1.png": "JO7E",
	"./supplychain/3_1.png": "UZIX",
	"./supplychain/4_1.png": "piXF",
	"./supplychain/PC.png": "ja10",
	"./supplychain/Phone.png": "9PsN",
	"./supplychain/Storage.png": "SM63",
	"./supplychain/arrow-down-s-fill.png": "GMfY",
	"./supplychain/arrow.png": "IK4y",
	"./supplychain/background.png": "cSeR",
	"./supplychain/banner-home.png": "CM7d",
	"./supplychain/banner-img.png": "hEDs",
	"./supplychain/chainhoverbg.png": "lTkl",
	"./supplychain/choice.png": "GORM",
	"./supplychain/database.png": "tyl8",
	"./supplychain/database_pre.png": "aTk1",
	"./supplychain/dispatch.png": "ae98",
	"./supplychain/dispatch1@2x.png": "9Rz2",
	"./supplychain/dispatch@2x.png": "1ki2",
	"./supplychain/globe.png": "GDON",
	"./supplychain/globe_pre.png": "zh5y",
	"./supplychain/home.png": "Utv9",
	"./supplychain/home_pre.png": "ka4S",
	"./supplychain/layers.png": "RmmC",
	"./supplychain/layers_pre.png": "fUeL",
	"./supplychain/logo.png": "/oCe",
	"./supplychain/package.png": "DS/L",
	"./supplychain/package_pre.png": "EbOp",
	"./supplychain/picture.png": "SEPK",
	"./supplychain/supplyDetail/banner.png": "VPqr",
	"./supplychain/supplyDetail/imgyd.png": "hzgm",
	"./supplychain/supplyDetail/info.png": "Bld5",
	"./supplychain/supplyDetail/info1.png": "y6hs",
	"./supplychain/supplyDetail/info2.png": "zlrv",
	"./supplychain/supplyDetail/ship-bg.png": "LAc+",
	"./supplychain/system.png": "rPbu",
	"./supplychain/water.png": "ygR9",
	"./topNav.png": "6pea",
	"./websitestated/websitebg.png": "CeQ1",
	"./yangluogangweb.png": "A0NE",
	"./zhonglitankuang.png": "7vgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 44